import React from 'react';

import { SelectBox } from 'common/FormField/formField';
import { MiceDropDownContainer } from './miceDropdownStyles';

const MiceDropDown = ({ field = {}, value }) => {
	field.value = field.options.filter((opt) => opt.value === value);
	const onChange = (val) => {
		field.value = val;
	};

	return (
		<MiceDropDownContainer>
			<SelectBox
				theme='mmt'
				bottom_M='5'
				className='mice'
				f_Size='14px'
				field={field}
				onChange={onChange}
			/>
		</MiceDropDownContainer>
	);
};

export default MiceDropDown;
